export const GLOBAL_STATE = 'Assessment'

export const ASSESSMENT = 'ASSESSMENT' as const
export const ASSESSMENT_CREATE = 'ASSESSMENT_CREATE' as const
export const ASSESSMENT_DELETE = 'ASSESSMENT_DELETE' as const
export const ASSESSMENT_LIST = 'ASSESSMENT_LIST' as const
export const ASSESSMENT_BULK = 'ASSESSMENT_BULK' as const
export const ASSESSMENT_LOG_MODAL = 'ASSESSMENT_LOG_MODAL' as const
export const ASSESSMENT_LOG_SUBMIT = 'ASSESSMENT_LOG_SUBMIT' as const
export const ASSESSMENT_ATTEMPT = 'ASSESSMENT_ATTEMPT' as const
export const ASSESSMENT_ATTEMPT_ITEM = 'ASSESSMENT_ATTEMPT_ITEM' as const
export const ASSESSMENT_ATTEMPT_DELETE = 'ASSESSMENT_ATTEMPT_DELETE' as const
export const ASSESSMENT_SUBMIT = 'ASSESSMENT_SUBMIT' as const
export const ASSESSMENT_COPY = 'ASSESSMENT_COPY' as const
export const ASSESSMENT_CRITERIA = 'ASSESSMENT_CRITERIA' as const
export const ASSESSMENT_CRITERIA_UPDATE = 'ASSESSMENT_CRITERIA_UPDATE' as const
export const ASSESSMENT_CRITERIA_STATUS = 'ASSESSMENT_CRITERIA_STATUS' as const
export const ASSESSMENT_CRITERIA_LIST = 'ASSESSMENT_CRITERIA_LIST' as const
export const ASSESSMENT_CRITERIA_TYPES = 'ASSESSMENT_CRITERIA_TYPES' as const
export const ASSESSMENT_STUDENT_UPLOAD = 'ASSESSMENT_STUDENT_UPLOAD' as const
export const ASSESSMENT_STUDENT = 'ASSESSMENT_STUDENT' as const
export const ASSESSMENT_STUDENT_UPDATED = 'ASSESSMENT_STUDENT_UPDATED' as const
export const ASSESSMENT_STUDENT_CRITERIA_DETAILS = 'ASSESSMENT_STUDENT_CRITERIA_DETAILS' as const
export const ASSESSMENT_STUDENT_QR_SAVE = 'ASSESSMENT_STUDENT_QR_SAVE' as const
export const ASSESSMENT_STUDENT_QR_LIST = 'ASSESSMENT_STUDENT_QR_LIST' as const
export const ASSESSMENT_MODERATION = 'ASSESSMENT_MODERATION' as const
